/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Workbenchaccess1Inputs */

const en_common_workbenchaccess1 = /** @type {(inputs: Common_Workbenchaccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workbench Access`)
};

/**
* | output |
* | --- |
* | "Workbench Access" |
*
* @param {Common_Workbenchaccess1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_workbenchaccess1 = /** @type {((inputs?: Common_Workbenchaccess1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Workbenchaccess1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_workbenchaccess1(inputs)
});
export { common_workbenchaccess1 as "common_workbenchAccess" }